import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import "./zenCursor.css";

export default function ZenCursor() {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const move = (e) => {
      setPos({ x: e.clientX, y: e.clientY });
      if (!visible) setVisible(true);
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [visible]);

  const cursor = (
    <div
      className={`zen-cursor ${visible ? "visible" : ""}`}
      style={{ left: pos.x, top: pos.y }}
    >
      <div className="zen-core"></div>
      <div className="zen-ripple"></div>
    </div>
  );

  if (typeof document === "undefined") return null;
  return createPortal(cursor, document.body);
}
